module.exports = function customIf(condition, trueValue, falseValue) {
  if (condition) {
    return trueValue;
  } else {
    return falseValue;
  }
};
